import React from "react"
import Layout from "components/layout"
import SEO from "components/seo"

const PrivacyPolicyPage = () => {
  return (
    <Layout active="privacy-policy" bottomInfo={false}>
      <SEO title="Privacy Policy" />
      <div className="h-40 w-full"></div>
      <div className="grid grid-cols-3 w-11/12 mx-auto mb-32">
        <div className="col-span-3 md:col-span-1">
          <div className="mb-6">
            <button className="font-bold text-base text-green h-12">
              Privacy and Policy
            </button>
          </div>
          <div className="mb-6">
            <button className="font-medium text-base text-grey-200">
              Lorem ipsum dolor
            </button>
          </div>
          <div className="mb-6">
            <button className="font-medium text-base text-grey-200">
              Lorem ipsum dolor
            </button>
          </div>
        </div>
        <div className="col-span-3 md:col-span-2">
          <div className="md:w-11/12 xl:w-10/12">
            <h1 className="text-grey-100 text-3xl font-bold">
              Lorem ipsum dolor sit amet
            </h1>
            <p className="mt-4 text-grey-200" style={{ lineHeight: "38px" }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac massa
              vitae, fames quis. Dolor sodales nisl mattis senectus ullamcorper.
              Eu at cras arcu, tempor interdum duis purus pellentesque. Turpis
              diam adipiscing urna tincidunt sed. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit. Ac massa vitae, fames quis. Dolor
              sodales nisl mattis senectus ullamcorper. Eu at cras arcu, tempor
              interdum duis purus pellentesque. Turpis diam adipiscing urna
              tincidunt sed.
            </p>
            <p className="mt-4 text-grey-200" style={{ lineHeight: "38px" }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac massa
              vitae, fames quis. Dolor sodales nisl mattis senectus ullamcorper.
              Eu at cras arcu, tempor interdum duis purus pellentesque. Turpis
              diam adipiscing urna tincidunt sed. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit. Ac massa vitae, fames quis. Dolor
              sodales nisl mattis senectus ullamcorper. Eu at cras arcu, tempor
              interdum duis purus pellentesque. Turpis diam adipiscing urna
              tincidunt sed.
            </p>
            <p className="mt-4 text-grey-200" style={{ lineHeight: "38px" }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac massa
              vitae, fames quis. Dolor sodales nisl mattis senectus ullamcorper.
              Eu at cras arcu, tempor interdum duis purus pellentesque. Turpis
              diam adipiscing urna tincidunt sed. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit. Ac massa vitae, fames quis. Dolor
              sodales nisl mattis senectus ullamcorper. Eu at cras arcu, tempor
              interdum duis purus pellentesque. Turpis diam adipiscing urna
              tincidunt sed.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default PrivacyPolicyPage
